var _excluded = ["desc", "focusable", "title", "iconName", "className"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from 'react';
import { string, bool } from 'prop-types';
import classNames from 'classnames';
var svg = /*#__PURE__*/React.createElement("svg", {
  viewBox: "0 0 32 32"
}, /*#__PURE__*/React.createElement("path", {
  d: "M23.996 14v-.349a2.4 2.4 0 00-2.383-2.409h-2.53a.72.72 0 01-.734-.702v-.007a3.692 3.692 0 01.253-.9c.118-.431-.047-.92-.825-.92h-.573a1.15 1.15 0 01-.196-2.284v-1.02a2.156 2.156 0 00.196 4.304h.34a1.73 1.73 0 001.54 2.53h2.529a1.381 1.381 0 011.383 1.38V14zM6 15h16v3H6zm17 0h1v3h-1zm2 0h1v3h-1zm-2.903-5.613a3.36 3.36 0 00-3.101-3.97v1a2.361 2.361 0 011.97 3.275 1.126 1.126 0 00-.068.23c-.018.25.11.465.47.465h.678A2.958 2.958 0 0125 13.343V14h1v-.657a3.96 3.96 0 00-3.903-3.956z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16 2a14 14 0 1014 14A14 14 0 0016 2zm13 14a12.938 12.938 0 01-3.134 8.452L7.553 6.139A12.983 12.983 0 0129 16zM3 16a12.953 12.953 0 013.139-8.447l18.313 18.313A12.99 12.99 0 013 16z"
}));

var Icon = function Icon(_ref) {
  var desc = _ref.desc,
      _ref$focusable = _ref.focusable,
      focusable = _ref$focusable === void 0 ? false : _ref$focusable,
      title = _ref.title,
      iconName = _ref.iconName,
      className = _ref.className,
      rest = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    focusable: String(focusable),
    className: classNames('rds-svg--smoking-prohibited-circle-icon', className)
  }, rest, svg.props), title && /*#__PURE__*/React.createElement("title", null, title), desc && /*#__PURE__*/React.createElement("desc", null, desc), svg.props.children);
};

Icon.propTypes = {
  desc: string,
  focusable: bool,
  title: string,
  iconName: string,
  className: string
};
Icon.displayName = 'SmokingProhibitedCircleIcon';
export default Icon;